<template>
  <div class="select-prev-task-dialog">
    <base-dialog
      :visible.sync="dialogVisible"
      class="select-prev-task-dialog-wrap"
      show-close
      width="485px"
    >
      <template v-slot:header>
        添加前置任务
      </template>
      <div class="top-wrap">
        <search-box :project-id="projectId" @search="setSearchInfo"></search-box>
      </div>
      <task-table
        ref="taskTable"
        from="selectPrev"
        :project-id="projectId"
        :search-info="searchInfo"
        :show-selection="false"
        :ignore-task-id="taskId"
        @row-click="rowClick"
      ></task-table>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import TaskTable from "@/views/Front/Project/TaskList/TaskTable"
import SearchBox from "@/views/Front/Project/TaskList/SearchBox"

export default {
  name: "SelectPrevTaskDialog",
  components: {
    SearchBox,
    TaskTable,
    BaseDialog
  },
  props: {
    projectId: String,
    taskId: String
  },
  data() {
    return {
      dialogVisible: false,
      select: "",
      searchInfo: {
        searchKey: null,
        searchValue: null
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.taskTable?.init()
      })
    },
    setSearchInfo(searchKey, searchValue) {
      this.searchInfo = {
        searchKey,
        searchValue
      }
    },
    rowClick(data) {
      this.$emit("select", data)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.select-prev-task-dialog-wrap {
  ::v-deep .el-dialog {
    min-width: 1080px;
    height: 86%;
    color: $color-font-first;
    .title {
      font-size: $font-size-title-second;
      font-weight: bold;
    }
    .el-dialog__headerbtn {
      top: 12px;
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .top-wrap {
        display: flex;
        align-items: center;
        height: 57px;
        margin: 0 20px;
        .search-box {
          margin-left: auto;
        }
      }
      .task-table {
        flex: auto;
        margin-bottom: 8px;
        overflow: hidden;
      }
      .pagination-wrap {
        margin-top: 6px;
      }
    }
  }
}
</style>
